<template>
  <div class="ui-image">

      <div class="ui-image-pane" :class="{vignette}" >
          <div></div>

          <div style="margin-bottom:15px;">
              <h1><slot name="subtitle">{{title}}</slot></h1>
              <slot name="subtitle"><h2>{{subtitle}}</h2></slot>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'UiHeaderStandard',
  props : {
    title : {type:String,default:""},
    subtitle : {type:String,default:""},
    vignette : {type:Boolean,default:false},
  },
  components: {

  },
  data()
  {
    return {
    }
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
  .ui-image
  {
    display:flex;
    height:100%;
    flex-direction: column;

  }
    .ui-image-pane
    {
        padding:16px;
        padding-bottom:30px;
        display:flex;
        flex-direction:column;
        justify-content: space-between;
        height:100%;
        color:white;

    }
    .ui-image-pane.vignette
    {
      box-shadow: inset 0px -80px 50px rgba(0,0,0,0.6),inset 0px 60px 80px rgba(0,0,0,0.6);
      text-shadow: .5px .5px 3px rgba(0,0,0,0.5);
    }

</style>
